import React from 'react';
import { Box, Typography } from '@mui/material';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: 2.5,
};

const publisherGrid = {
    display: 'grid',
    gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)' },
    gap: 1.5,
    mt: 2,
};

const coverBox = {
    width: '125px',
    height: '125px',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.10)',
    transition: 'border-color 0.18s ease',
    background: 'rgba(255,255,255,0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { borderColor: 'rgba(0,215,255,0.6)' },
};

function Collections({ publishers = [] }) {
    function renderEmpty() {
        return (
            <Typography sx={{ fontSize: '0.875rem', color: 'var(--ecal-lightgrey)', mt: 1 }}>
                No favourites yet — start syncing to build your collection.
            </Typography>
        );
    }

    function renderPublishers() {
        return (
            <Box sx={publisherGrid}>
                {publishers.map((p) => (
                    <Box key={p.id || p.pubId}>
                        <Box sx={{ ...coverBox, background: p.logoColors?.length >= 2
                            ? `linear-gradient(135deg, ${p.logoColors[0]}, ${p.logoColors[1]})`
                            : 'rgba(255,255,255,0.04)'
                        }}>
                            {p.logo
                                ? <Box component="img" src={p.logo} alt={p.name} sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }} />
                                : <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, color: '#fff' }}>{p.name?.[0]}</Typography>
                            }
                        </Box>
                        <Typography sx={{ fontSize: '12px', color: 'var(--ecal-white)', mt: 0.75, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {p.name}
                        </Typography>
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2.16px', color: 'var(--ecal-lightblue)' }}>
                Your collection
            </Typography>
            {publishers.length === 0 ? renderEmpty() : renderPublishers()}
        </Box>
    );
}

export default Collections;
